/*
 * Empty cart drawer extras (Best Sellers + Bundle card) - same behaviour as the NA store:
 *  - the extras are NOT part of the page / drawer HTML. The drawer renders an empty slot ([data-empty-upsell]) and this script
 *    fetches the extras once (section mode __nobl_empty__), caches them and puts them into the slot when the drawer opens.
 *  - the fetch is started early when the cart icon is hovered / touched / focused.
 *  - bundle card swatches update image, price, "Save" text, badge and button link.
 * Loaded from snippets/free-gift.liquid.
 */
(function () {
  if (window.__noblEmptyExtras) return;
  window.__noblEmptyExtras = true;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var MARK = '__nobl_empty__';
  var html = null, promise = null;

  function drawer() { return document.getElementById('cart-drawer') || document.querySelector('cart-drawer'); }
  function sectionId() {
    var d = drawer();
    // the theme moves the dialog out of its section wrapper once opened, so remember the id
    if (d && d.nobl_sectionId) return d.nobl_sectionId;
    if (d && d.__noblEmptySid) return d.__noblEmptySid;
    var s = d && d.closest('.shopify-section');
    if (!s) s = document.querySelector('.shopify-section--cart-drawer, [id^="shopify-section-"][id$="cart-drawer"]');
    var id = s ? s.id.replace(/^shopify-section-/, '') : 'cart-drawer';
    if (d && s) d.__noblEmptySid = id;
    return id;
  }
  function slot(d) { return d ? d.querySelector('[data-empty-upsell]:not([data-loaded])') : null; }

  function fetchExtras() {
    if (html !== null) return Promise.resolve(html);
    if (promise) return promise;
    promise = fetch(ROOT + 'search?q=' + MARK + '&section_id=' + sectionId(), { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var root = doc.querySelector('.nobl-empty-root');
        if (!root) throw new Error('no root');
        if (!root.innerHTML.trim()) throw new Error('empty');
        html = root.innerHTML;
        return html;
      })
      .catch(function (e) { promise = null; throw e; });
    return promise;
  }

  function insert(s) {
    if (!html) return;
    s.innerHTML = html;
    s.setAttribute('data-loaded', '');
    var dr = drawer(); if (dr) dr.classList.add('nobl-ceu-loaded');
  }

  function load() {
    var d = drawer();
    var s = slot(d);
    if (!s) return;
    if (html !== null) { insert(s); return; }
    d.classList.add('nobl-ceu-loading');
    fetchExtras()
      .then(function () { var s2 = slot(d); if (s2) insert(s2); })
      .catch(function () {})
      .then(function () { d.classList.remove('nobl-ceu-loading'); });
  }
  function prefetch() { if (slot(drawer())) fetchExtras().catch(function () {}); }

  // cart icon intent -> start fetching before the drawer opens
  var ICON = 'a[href$="/cart"], [aria-controls="cart-drawer"], #cart-icon-bubble';
  ['pointerover', 'touchstart', 'focusin'].forEach(function (name) {
    document.addEventListener(name, function (e) {
      if (e.target && e.target.closest && e.target.closest(ICON)) prefetch();
    }, { capture: true, passive: true });
  });

  // drawer opening / drawer content repainted (add to cart, last item removed, ...)
  var queued = false;
  function check() {
    var d = drawer();
    if (!d || !slot(d)) return;
    if (d.open || d.hasAttribute('open') || html !== null) load();
  }
  function queue() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; check(); });
  }
  function watch() {
    var d = drawer();
    if (!d || d.__noblEmptyWatch) return;
    d.__noblEmptyWatch = true;
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        if (records[i].type === 'attributes' || (records[i].addedNodes && records[i].addedNodes.length)) { queue(); return; }
      }
    }).observe(d, { childList: true, subtree: true, attributes: true, attributeFilter: ['open'] });
    ['dialog:before-show', 'dialog:after-show'].forEach(function (name) { d.addEventListener(name, queue); });
    queue();
  }
  watch();
  document.addEventListener('DOMContentLoaded', watch);

  // bundle card swatches
  document.addEventListener('change', function (e) {
    var inp = e.target;
    if (!inp || !inp.matches || !inp.matches('.cart-empty-bundle-card__swatches input')) return;
    var card = inp.closest('.cart-empty-bundle-card');
    var dataEl = card && card.querySelector('script[data-bundle-variants]');
    if (!dataEl) return;
    var map;
    try { map = JSON.parse(dataEl.textContent); } catch (err) { return; }
    var v = map[inp.value];
    if (!v) return;

    var img = card.querySelector('.cart-empty-bundle-card__image');
    if (img && v.img) { img.removeAttribute('srcset'); img.src = v.img; }
    var price = card.querySelector('[data-bundle-price]');
    if (price) price.textContent = v.price;
    var compare = card.querySelector('[data-bundle-compare]');
    if (compare) { compare.textContent = v.compare || ''; compare.hidden = !v.compare; }
    var sub = card.querySelector('[data-bundle-subtitle]');
    if (sub) {
      var tpl = card.getAttribute('data-sub-tpl') || '';
      var text = tpl.indexOf('[savings]') > -1 ? (v.save ? tpl.replace('[savings]', v.save) : '') : tpl;
      sub.textContent = text; sub.hidden = !text;
    }
    var badge = card.querySelector('[data-bundle-badge]');
    if (badge) {
      var bt = card.getAttribute('data-badge-tpl') || '';
      var btext = bt.indexOf('[percent]') > -1 ? (v.pct ? bt.replace('[percent]', v.pct) : '') : bt;
      badge.textContent = btext; badge.hidden = !btext;
    }
    var btn = card.querySelector('[data-bundle-button]');
    var url = card.getAttribute('data-product-url');
    if (btn && url) btn.setAttribute('href', url + '?variant=' + v.id);
  });
})();
